import { render, staticRenderFns } from "./teachingSuggestions.vue?vue&type=template&id=120ed907&scoped=true"
import script from "./teachingSuggestions.vue?vue&type=script&lang=js"
export * from "./teachingSuggestions.vue?vue&type=script&lang=js"
import style0 from "./teachingSuggestions.vue?vue&type=style&index=0&id=120ed907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ed907",
  null
  
)

export default component.exports